// ═══════════════════════════════════════════════════════════════════
//  search/telemetry — Lightweight client-side counters.
// ═══════════════════════════════════════════════════════════════════
//
//  Wraps the shared createTelemetryStore from `lib/telemetryStore.ts`
//  with the search-specific event union. Public API is unchanged for
//  callers (logSearchEvent / getSearchTelemetryLog /
//  clearSearchTelemetry) — backwards-compatible after the v1.2
//  consolidation.
//
// ═══════════════════════════════════════════════════════════════════

import { createTelemetryStore } from '@/lib/telemetryStore';

export type SearchTelemetryEvent =
  | { kind: 'query'; query: string; resultCount: number; scope: string; durationMs: number }
  | { kind: 'canvas-opened'; query: string; scope: string }
  | { kind: 'hit-click'; sourceType: string }
  | { kind: 'probe'; action: 'neighbors' | 'similar' | 'trace-path' };

const store = createTelemetryStore<SearchTelemetryEvent>({
  debugFlag: '__FW_SEARCH_DEBUG',
  debugPrefix: '[search-telemetry]',
});

export function logSearchEvent(ev: SearchTelemetryEvent): void {
  store.log(ev);
}

export function getSearchTelemetryLog(): readonly SearchTelemetryEvent[] {
  return store.get();
}

export function clearSearchTelemetry(): void {
  store.clear();
}

/** Atomically pull the buffer for backend ingestion. */
export function takeSearchTelemetry(): SearchTelemetryEvent[] {
  return store.getAndClear();
}
